import { PropsWithChildren } from 'react';

import { ButtonBase } from '@mui/material';
import { CloseIcon } from 'icons';
import { selectIsDarkTheme } from 'modules/app/state';
import { useAppSelector } from 'store';

import { SnackbarWrapper } from './Snackbar.styled';
import { SnackbarIcon, SnackbarIconProps } from './SnackbarIcon';

type Props = SnackbarIconProps & {
  onClose?(): void;
};

export const Snackbar = ({ severity, children, onClose }: PropsWithChildren<Props>) => {
  const isDarkTheme = useAppSelector(selectIsDarkTheme);

  return (
    <SnackbarWrapper isDarkTheme={isDarkTheme}>
      <SnackbarIcon severity={severity} />
      {children}
      {onClose && (
        <ButtonBase onClick={onClose}>
          <CloseIcon fontSize="small" />
        </ButtonBase>
      )}
    </SnackbarWrapper>
  );
};
